import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Descriptions,
  Avatar,
  Image,
  Drawer,
  Form,
  Input,
  Upload,
  Space,
  message,
  Checkbox,
  Alert,
  Popconfirm,
  Tag,
} from "antd";
import { Iconify } from "utils/Iconify";

import BgProfile from "assets/images/bg-profile4.jpg";

import { useNavigate, useParams } from "react-router-dom";
import {
  PlusOutlined,
  DeleteOutlined,
  UploadOutlined,
  StarOutlined,
  MoneyCollectOutlined,
} from "@ant-design/icons";

import { getProductDetail } from "services/product";
import { upload } from "services/upload"; // <== SAME AS CATEGORY
import {
  createVariant,
  updateProductVariant,
  updateProduct,
  uploadProductImage,
} from "services/product";
import { deleteProductImage } from "services/product";
import { deleteProductVariant } from "services/product";
import { deleteProduct } from "services/product";
import { debounce } from "lodash";
import { getDataFromAccurate } from "services/accurate";
import { getDatabase } from "services/accurate";

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState({ images: [], variants: [] });
  const [imageUrl, setImageUrl] = useState(null);
  const [dbAccurate, setDBAccurate] = useState(null);

  const [drawerType, setDrawerType] = useState(null);
  const [visible, setVisible] = useState(false);

  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [idVariant, setIdVariant] = useState(null);

  const openDrawer = (type, initData) => {
    setDrawerType(type);
    setVisible(true);
    form.resetFields();
    form.setFieldsValue(initData);
  };

  const onClose = () => {
    setVisible(false);
    setDrawerType(null);
    setFileList([]);
    form.resetFields();
  };

  const fetchProduct = async (id) => {
    try {
      const response = await getProductDetail({ id });
      if (response?.result) {
        setProduct(response.result);
      }
    } catch (err) {
      console.error(err);
    }
  };

  function extractInfo(text) {
    const daftarWarna = [
      "hitam bening",
      "putih polos",
      "hitam",
      "bening",
      "putih",
    ];

    const lower = text.toLowerCase();

    // Cari warna
    let color = null;
    for (const w of daftarWarna.sort((a, b) => b.length - a.length)) {
      if (lower.includes(w)) {
        color = w;
        break;
      }
    }

    // Cari size (ambil angka + satuan)
    let size = null;
    const regexSize = /\(([^)]+)\)/; // ambil yang dalam kurung
    const match = text.match(regexSize);
    if (match) {
      // cari pola angka + satuan (contoh: 2,1 Kg / 1.5 Kg / 500 gr / 50 Meter)
      const regexInner = /(\d[\d.,]*)\s*(kg|gr|meter|m|cm)/i;
      const innerMatch = match[1].match(regexInner);
      if (innerMatch) size = `${innerMatch[1]} ${innerMatch[2]}`;
    }

    return { color, size };
  }

  const fetchItemData = async (itemNo) => {
    try {
      let { token, host, session } = dbAccurate;
      const body = {
        session,
        token,
        api_url: `${host}/accurate/api/item/list.do?fields=name,no,id,unit1,unitPrice&filter.keywords.op=EQUAL&filter.keywords.val=${itemNo}`,
      };

      const res = await getDataFromAccurate(body);
      if (res?.d?.length) {
        const data = res.d[0];
        const { unitPrice, id, name } = data;
        const { color, size } = extractInfo(name);

        form.setFieldsValue({
          price: unitPrice,
          item_id: id,
          product_name: name,
          color,
          size,
        });
        return;
      }

      form.setFieldsValue({
        price: 0,
        item_id: "",
        product_name: "",
        color: "",
        size: "",
      });
    } catch (e) {
      console.error(e);
    }
  };

  const debounceFetch = debounce((value) => {
    if (value) fetchItemData(value);
  }, 800);

  const getDBAccurate = async () => {
    try {
      const response = await getDatabase();

      if (response?.data) {
        const db = response.data.find((x) =>
          x.dbname.toLowerCase().includes("mitra")
        );

        setDBAccurate(db);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getDBAccurate();
  }, []);

  useEffect(() => {
    if (id) fetchProduct(id);
  }, [id]);

  // ========================================================================
  // UPLOAD IMAGE
  // ========================================================================
  const handleUpload = async (file) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await upload(formData);
      const data = await response.json();

      if (data.status === "success") {
        setImageUrl(data.file_path);
      } else {
        message.error("Upload failed!");
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to upload image!");
    } finally {
      setUploading(false);
    }

    return false;
  };

  // ========================================================================
  // SUBMIT DRAWERS
  // ========================================================================
  const handleSubmit = async (values) => {
    try {
      if (drawerType === "variant-add") {
        await createVariant({ product_id: id, availability: 0, ...values });
        message.success("Variant added!");
      }

      if (drawerType === "variant-edit") {
        await updateProductVariant({
          id: idVariant,
          ...values,
        });
        message.success("Variant updated!");
      }

      if (drawerType === "description") {
        await updateProduct({ id, ...values });
        message.success("Description updated!");
      }

      if (drawerType === "image") {
        await uploadProductImage({
          product_id: id,
          image_url: imageUrl,
        });
        message.success("Image added!");
      }

      fetchProduct(id);
      setIdVariant(null);
      onClose();
    } catch (err) {
      console.error(err);
      message.error("Failed!");
    }
  };

  const handleUpdateStatus = async (values) => {
    try {
      await updateProduct({ id, ...values });
      message.success("Description updated!");

      fetchProduct(id);
    } catch (err) {
      console.error(err);
      message.error("Failed!");
    }
  };

  const handleDeleteImage = async (imageId) => {
    await deleteProductImage(imageId);
    message.success("Product image deleted!");
    fetchProduct(id);
  };

  const handleDeleteVariant = async (variantId) => {
    await deleteProductVariant(variantId);
    message.success("Product variant deleted!");
    fetchProduct(id);
  };

  return (
    <>
      <div
        className="profile-nav-bg"
        style={{
          backgroundImage: `url(${BgProfile})`,
          color: "white !important",
        }}
      />

      <Card
        className="card-profile-head"
        bodyStyle={{ display: "none" }}
        title={
          <Row justify="space-between" align="middle" gutter={[24, 0]}>
            <Col span={24} md={12} className="col-info">
              <Avatar.Group>
                <div className="avatar-info">
                  <h4 className="font-semibold m-0">{product.name}</h4>
                  <p>
                    {product.brand || "-"}{" "}
                    {product.is_promo == "1" && (
                      <span>
                        <Tag color="green">Promo</Tag>
                      </span>
                    )}
                    {product.is_bestselling == "1" && (
                      <span>
                        <Tag color="geekblue">Best Selling</Tag>
                      </span>
                    )}
                  </p>
                </div>
              </Avatar.Group>
            </Col>
            <Col
              span={24}
              md={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Space>
                <Popconfirm
                  placement="top"
                  title={`Are you sure you want to remove this product?`}
                  onConfirm={async () => {
                    await deleteProduct(id);
                    message.success("Product deleted!");
                    navigate("/ecommerce/product");
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="primary" danger icon={<DeleteOutlined />}>
                    Delete Product
                  </Button>
                </Popconfirm>
                <Button
                  type="primary"
                  icon={<MoneyCollectOutlined />}
                  onClick={() =>
                    handleUpdateStatus({
                      ...product,
                      is_promo: product.is_promo == "1" ? "0" : "1",
                    })
                  }
                >
                  {product.is_promo == "1" ? "Unset Promo" : "Set Promo"}
                </Button>
                <Button
                  type="primary"
                  icon={<StarOutlined />}
                  onClick={() =>
                    handleUpdateStatus({
                      ...product,
                      is_bestselling: product.is_bestselling == "1" ? "0" : "1",
                    })
                  }
                >
                  {product.is_bestselling == "1"
                    ? "Unset Best Selling"
                    : "Set Best Selling"}
                </Button>
              </Space>
            </Col>
          </Row>
        }
      />

      {/* ===================== PRODUCT IMAGES ===================== */}
      <Row gutter={[24, 0]}>
        <Col span={24} md={24} className="mb-24">
          <Card
            bordered={false}
            className="header-solid h-full relative"
            title={<h6 className="font-semibold m-0">Images</h6>}
            extra={
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => openDrawer("image", null)}
              >
                Add Image
              </Button>
            }
          >
            <Image.PreviewGroup>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                {product.images?.map((img, index) => (
                  <div key={index} style={{ position: "relative", width: 300 }}>
                    <Image
                      width={300}
                      src={img.image_url}
                      style={{ borderRadius: 8 }}
                    />

                    <Button
                      type="primary"
                      danger
                      size="small"
                      icon={<DeleteOutlined />}
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        borderRadius: "50%",
                      }}
                      onClick={() => handleDeleteImage(img.id)}
                    />
                  </div>
                ))}
              </div>
            </Image.PreviewGroup>
          </Card>
        </Col>

        <Col span={24} md={16} className="mb-24">
          <Card
            bordered={false}
            title={<h6 className="font-semibold m-0">Descriptions</h6>}
            className="header-solid h-full card-profile-information"
            extra={
              <Button
                type="primary"
                onClick={() => openDrawer("description", product)}
              >
                Edit Description
              </Button>
            }
            bodyStyle={{ paddingTop: 0, paddingBottom: 16 }}
          >
            <p className="text-dark">
              <pre>{product.description}</pre>
            </p>
            <hr className="my-25" />
            <Descriptions title="Attribute">
              <Descriptions.Item label="Category" span={3}>
                {product.category}
              </Descriptions.Item>
              <Descriptions.Item label="Tag" span={3}>
                {product.tag || "-"}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>

        <Col span={24} md={8} className="mb-24">
          <Card
            bordered={false}
            className="header-solid h-full"
            title={<h6 className="font-semibold m-0">Variants</h6>}
            extra={
              <Button
                type="primary"
                onClick={() => openDrawer("variant-add", { availability: 0 })}
              >
                Add Variant
              </Button>
            }
          >
            <Row gutter={[24, 24]}>
              {product.variants.map((i, index) => (
                <Col span={24} key={index}>
                  <Alert type="success" message={i.product_name || "-"} />
                  <Card className="card-billing-info" bordered={false}>
                    <div className="col-info">
                      <Descriptions title={i.item_no || "-"}>
                        <Descriptions.Item label="Size" span={3} key={index}>
                          {i.size || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Color" span={3} key={index}>
                          {i.color || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Price" span={3} key={index}>
                          {i.price || 0}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="Special Price"
                          span={3}
                          key={index}
                        >
                          {i.special_price || 0}
                        </Descriptions.Item>
                        <Descriptions.Item label="Stock" span={3} key={index}>
                          {i.stock || 0}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="Availability"
                          span={3}
                          key={index}
                        >
                          {i.availability || 0}
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                    <div className="col-action">
                      <Button
                        type="link"
                        danger
                        onClick={() => handleDeleteVariant(i.id)}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          key={0}
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z"
                            fill="#111827"
                            className="fill-danger"
                          ></path>
                        </svg>
                        DELETE
                      </Button>
                      <Button
                        type="link"
                        className="darkbtn"
                        onClick={() => {
                          openDrawer("variant-edit", i);
                          setIdVariant(i.id);
                        }}
                      >
                        <Iconify icon="akar-icons:pencil" /> EDIT
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
      </Row>

      {/* ===========================================================
              DRAWER CONTENT
      =========================================================== */}
      <Drawer
        title={
          drawerType === "image"
            ? "Add Image"
            : drawerType === "variant-add"
            ? "Add Variant"
              ? drawerType === "variant-edit"
              : "Edit Variant"
            : "Edit Description"
        }
        width={400}
        visible={visible}
        onClose={onClose}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          {/* IMAGE UPLOAD FORM */}
          {drawerType === "image" && (
            <Form.Item label="Image" name="image">
              {imageUrl ? (
                <div style={{ textAlign: "center" }}>
                  <Image
                    width={200}
                    src={imageUrl}
                    alt="Product Image"
                    style={{ borderRadius: 8 }}
                  />
                  <div style={{ marginTop: 10 }}>
                    <Button
                      type="link"
                      onClick={() => {
                        form.setFieldsValue({ image: "" });
                        setImageUrl("");
                      }}
                    >
                      Change Image
                    </Button>
                  </div>
                </div>
              ) : (
                <Upload
                  listType="picture"
                  fileList={fileList}
                  beforeUpload={handleUpload}
                  onChange={({ fileList }) => setFileList(fileList)}
                  showUploadList={false}
                  accept="image/*"
                >
                  <Button
                    icon={<UploadOutlined />}
                    loading={uploading}
                    disabled={uploading}
                  >
                    {uploading ? "Uploading..." : "Upload Image"}
                  </Button>
                </Upload>
              )}
            </Form.Item>
          )}

          {/* ADD VARIANT FORM */}
          {(drawerType === "variant-add" || drawerType === "variant-edit") && (
            <>
              <Form.Item
                name="item_no"
                label="Item No"
                rules={[{ required: true }]}
              >
                <Input
                  onChange={(e) => {
                    const value = e.target.value;
                    debounceFetch(value);
                  }}
                />
              </Form.Item>
              <Form.Item
                name="item_id"
                label="Item Id"
                rules={[{ required: true }]}
              >
                <Input disabled={true} />
              </Form.Item>
              <Form.Item
                name="product_name"
                label="Product Name"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={2} disabled={true} />
              </Form.Item>

              <Form.Item name="size" label="Size" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item
                name="color"
                label="Color"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="price"
                label="Price"
                rules={[{ required: true }]}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                name="special_price"
                label="Special Price"
                rules={[{ required: true }]}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                name="stock"
                label="Stock"
                rules={[{ required: true }]}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                name="availability"
                label="Availability"
                valuePropName="checked"
                getValueFromEvent={(e) => (e.target.checked ? 1 : 0)}
              >
                <Checkbox />
              </Form.Item>
            </>
          )}

          {/* EDIT DESCRIPTION FORM */}
          {drawerType === "description" && (
            <>
              <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item
                name="category"
                label="Category"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="brand"
                label="Brand"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="tag" label="Tag" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={6} />
              </Form.Item>
            </>
          )}

          {/* BUTTONS */}
          <Form.Item>
            <Space style={{ float: "right" }}>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}
